import { alertDialog } from './alertDialog.js';
import { forceBlur } from './forceBlur.js';

const dom = {
    alertDialog,
    forceBlur
};

export { dom };
